import { SimpleGrid } from '@backyard-ui/core';

import { type Response as GetSummaryResponse } from '@/infra/services/catalog/review/get-summary';

import { Item } from './Item';

interface HelpfulReviewsProps {
  summary: GetSummaryResponse['data'];
}

function HelpfulReviews(props: Readonly<HelpfulReviewsProps>) {
  const { summary } = props;

  const badReview = summary.badRate;
  const goodReview = summary.goodRate;

  return (
    <SimpleGrid gapY="16" columns={{ initial: 1, md: 2 }}>
      {badReview && <Item review={badReview} />}
      {goodReview && <Item review={goodReview} isBad />}
    </SimpleGrid>
  );
}

export default HelpfulReviews;
